const getPath = (fragment = "") => `${process.env.PUBLIC_URL}${fragment}`;

export default getPath;
